$(function(){
    if( $("body").is("#site-search") ){
        var q = $.url().param("q");
        if(q){
            $("#header .box-search input[type='text']").val(q);
        }
    }
});


// WEBPACK FOOTER //
// ./_src/js/cont/site-search.js